<template>
  <tool-advance-filter-content
    :addButtonText="addButtonText"
    :chartProperties="chartProperties"
    :chartData="chartGraphData"
    :linePlotData="linePlotData"
    :selectedComponent="superSelectedComponent"
    :updateButtonText="updateButtonText"
    :headers="headers"
    :rows="rows"
    :isNotShowGraph="isNotShowGraph"
    :contentInfo="contentInfo"
    :singleHeading="singleHeading"
    :isShowHint="isShowHint"
    :infoText="infoText"
    :infoError="infoError"
    :emptyChartMessage="emptyChartMessage"
    :focusElementName="focusElementName"
    :baselineTitle="baselineRow ? baselineRow.title : ''"
    :headerbaseline="baselineHeader"
    :rowsbaseline="baselineRow ? baselineRow.rows : []"
    :emptyGridData="emptyGridData"
    :rowOuterButton="rowOuterButton"
    :gridButtonTemplate="gridButtonTemplate"
    :singleHeadingOptions="singleHeadingOptions"
    :singleHeadingButtonText="singleHeadingButtonText"
    :gridSplitId="gridSplitId"
    @addRow="addRow"
    @editableRowButtonClick="genericMethodClick"
    @GridSelectionChange="AddNewTypeRow"
    :rowTemplateButton="rowTemplateButton"
    @rowTemplateButtonClick="genericMethodClick"
    @OuterRowButtonClick="genericMethodClick"
    @onChange="OnOptionChange"
    @removeRow="removeRow"
    @onChangeChartTab="onChangeSuperChartTab"
  ></tool-advance-filter-content>
</template>
<script>
import { ToolAdvanceFilterContent } from "../../component/tool";
import { AdvanceSuperFilter } from "../../helpers/constant";
import {
  EngagementBaseline,
  EngagementToolCommon,
  SuperannuationAdvanceFilterContent,
} from "../../mixin";
import { SuperFundType } from "../../helpers/constant";
import {
  GET_SELECTED_SUPERANNUATION_INFORMATION,
  GET_SUPERANNUATION_INFORMATION,
} from "../../helpers/vuex-constants";
import { mapGetters } from "vuex";
import _ from "lodash";
export default {
  props: {
    baselineData: {
      type: Array,
    },
    clientId: {
      type: Number,
    },
    clientName: {
      type: String,
    },
  },
  components: { ToolAdvanceFilterContent },
  computed: {
    ...mapGetters("superannuation", {
      selectedSuperannuationData: GET_SELECTED_SUPERANNUATION_INFORMATION,
      getSuperannuationInformation: GET_SUPERANNUATION_INFORMATION,
    }),
    legendItems() {
      return ["Base Return", "Return Adjustments"];
    },
    gridButtonTemplate() {
      let difference = true;
      let Superannuations = this.getSuperannuationInformation.filter(
        (sr) =>
          sr.superFundGuid == this.selectedSuperannuationData.superFundGuid
      );
      let ExistingData = Superannuations[0].superAddtionalDetails
        .filter(
          (sr) =>
            sr.typeId == AdvanceSuperFilter.Pension &&
            sr.clientID == this.clientId
        )
        .map(function (t) {
          let p = {};
          p.amount3 = t.amount3;
          p.amount1 = t.amount1;
          p.amount2 = t.amount2;
          p.description = t.description;
          p.startDate = t.startDate;
          p.endDate = t.endDate;
          p.riskProfile = t.riskProfile;
          p.startDateType = t.startDateType;
          p.endDateType = t.endDateType;
          p.clientID = t.clientID;
          return p;
        });

      let CurrentDataObject = [];
      for (let i = 0; i < this.rows.length; i++) {
        if (ExistingData.length > 0)
          CurrentDataObject.push({
            amount3: this.rows[i].amount3.value,
            amount1: this.rows[i].amount1.value,
            amount2: this.rows[i].amount2.value,
            description: this.rows[i].description.value,
            startDate: this.rows[i].startDate.value,
            endDate: this.rows[i].endDate.value,
            startDateType: this.rows[i].startDateType.value,
            endDateType: this.rows[i].endDateType.value,
            riskProfile: this.rows[i].riskProfile.value,
            clientID:
              this.rows[i].clientID == undefined
                ? this.clientId
                : this.rows[i].clientID.value,
          });
        else {
          if (!this.validatebyrow(this.rows[i], this.rows[i].subTypeId.value)) {
            difference = false;
            break;
          }
        }
      }
      if (ExistingData.length > 0) {
        difference = _.isEqual(ExistingData, CurrentDataObject);
      }
      this.enableResetButton(difference, "UpdateGraph");
      this.enableResetButton(difference, "reset");

      return this.gridButtonTemplatedata;
    },
    baselineRowFilterObject() {
      return Object.assign([], this.baselineData);
    },
  },
  mixins: [
    EngagementBaseline,
    EngagementToolCommon,
    SuperannuationAdvanceFilterContent,
  ],
  data() {
    return {
      contentInfo: {},
      emptyGridData: {
        title: "Click to add Additional Return",
        message: "",
        imagepath: "../../assets/icons/dollar.svg",
        buttonVisible: true,
        list: [],
      },
      timeSeriesChartData: [],
      rowOuterButton: [],
      focusElementName: "",
      rowTemplateButton: [
        {
          icon: "plus",
          size: "medium",
          variation: "flat",
          text: "Add New",
          callBackMethod: "AddNewTypeRow",
          isdisabled: false,
          key: "AddNewTypeRow",
        },
      ],
      gridButtonTemplatedata: [
        {
          icon: "eye",
          size: "medium",
          variation: "primary",
          text: "Preview Graph",
          callBackMethod: "UpdateGraph",
          isdisabled: false,
          key: "UpdateGraph",
        },
        {
          size: "medium",
          variation: "secondary",
          isdisabled: true,
          text: "Reset",
          callBackMethod: "reset",
          key: "reset",
        },
      ],

      emptyChartMessage: {
        message: "Add Drawdown details to create a chart.",
        btnTxt: "",
      },

      updateButtonText: "Preview Graph",
      addButtonText: "Add new",
      isShowHint: true,
      infoText: ["Hit 'Tab' to move to the next cell and add a new row"],
      singleHeadingOptions: [
        {
          key: 1,
          value: "",
          fields: [
            "riskProfile",
            "amount1",
            "amount2",
            "amount3",
            "startDate",
            "endDate",
            "description",
          ],
          overlapvalidations: true,
        },
      ],
      singleHeadingButtonText: "",
      gridSplitId: "",

      infoError: false,
      singleHeading: "Returns Adjustment",
      headers: [
        {
          type: "Dropdown",
          label: "Risk Profile",
          cols: 4,
          options: this.baselineData.riskProfileOption,
          defaultValue: 1,
          key: "riskProfile",
          validation: false,
          style: {
            width: "160px",
          },
        },
        {
          type: "FormatInput",
          label: "Income",
          cols: 1,
          key: "amount1",
          isAllowOnlyNumber: true,
          AllowOnlyDecimalTill: 2,
          appendText: "%",
          length: 6,
          max: 100,
          validation: false,
          style: {
            width: "100px",
          },
        },
        {
          type: "FormatInput",
          label: "Growth",
          cols: 1,
          key: "amount2",
          isAllowOnlyNumber: true,
          AllowOnlyDecimalTill: 2,
          appendText: "%",
          length: 6,
          max: 100,
          validation: false,
          style: {
            width: "100px",
          },
        },
        {
          type: "FormatInput",
          label: "Franking",
          cols: 1,
          key: "amount3",
          isAllowOnlyNumber: true,
          AllowOnlyDecimalTill: 2,
          appendText: "%",
          length: 6,
          max: 100,
          validation: false,
          style: {
            width: "100px",
          },
        },

        {
          type: "MonthPickerSelect",
          displayTop: true,
          typing: true,
          label: "Start",
          cols: 2,
          key: "startDate",
          listdata: this.startOptionsNew(),
          sort: "years",
          minYear: 2022,
          yearTerm: 50,

          style: {
            width: "120px",
            overflow: "visible",
          },
          validation: true,
        },

        {
          type: "MonthPickerSelect",
          displayTop: true,
          typing: true,
          label: "End",
          cols: 2,
          key: "endDate",
          listdata: this.startOptionsNew(),
          sort: "years",
          minYear: 2022,
          yearTerm: 50,

          style: {
            width: "120px",
            overflow: "visible",
          },
          validation: true,
        },
        {
          type: "Input",
          label: "Description",
          placeholder: "e.g Change in Rates",
          isAllowToAddNextRow: true,
          cols: 1,
          key: "description",
          isAllowOnlyNumber: false,
          appendText: "",
          length: 200,
          validation: false,
        },

        {
          type: "Icon",
          label: "",
          iconText: "Validation",
          icon: "check",
          cols: 1,
          isShowDelete: true,
          isShowSuccess: false,
          class: "cf-Icon-Align",
          style: {
            width: "50px",
          },
          data: [
            {
              label: "",
              iconText: "Delete",
              icon: "trash",
              type: "icon",
              path: "",
              action: "delete",
            },
          ],
        },
      ],
      rows: this.fillGrid(),
      baselineHeader: [],
      baselineRow: {},
      selectedFundType: SuperFundType.Pension,
      selectedOption: AdvanceSuperFilter.Pension,
    };
  },
  async created() {},
  beforeMount() {
    // this.fillSuperannuationModel(AdvanceSuperFilter.Pension);
    this.superValidations(
      this.baselineFilterObject.superAddtionalDetails,
      AdvanceSuperFilter.Pension,
      this.clientId
    );
  },
  beforeDestroy() {
    this.fillSuperannuationModel(AdvanceSuperFilter.Pension, this.clientId);
    this.superValidations(
      this.baselineFilterObject.superAddtionalDetails,
      AdvanceSuperFilter.Pension,
      this.clientId
    );
  },
  mounted() {
    this.baselineHeader = this.getReturnBaselineHeader();
    this.baselineRow = {
      title: "Baseline Return",
      rows: this.getbaselineRowData(),
    };

    this.contentInfo = {
      chartTabContent: this.getSuperTimeSeriesChartTab(),
      heading: ` ${this.clientName} Pension Return`,
      subHeading:
        "You can enter in different return at different time periods.",
      infoAlert: {
        title: "Important note",
        variation: "informational",
        text: "You can enter in different return at different time periods.",
      },
    };
  },
  methods: {
    async UpdateGraph() {
      await this.updateAllAdvanceSuperGraph(
        AdvanceSuperFilter.Pension,
        this.clientId
      );
    },
    getUserInputData(rows) {
      let addtionalData = [];
      for (let i = 0; i < rows.length; i++) {
        if (!this.validatebyrow(rows[i], rows[i].subTypeId.value)) {
          addtionalData.push({
            riskProfile: {
              value: rows[i].riskProfile.value,
              IsError: false,
              ErrorText: [],
              disable: rows[i].riskProfile.disable,
            },
            amount1: {
              value: rows[i].amount1.value,
              IsError: false,
              ErrorText: [],
              disable: rows[i].amount1.disable,
            },
            amount2: {
              value: rows[i].amount2.value,
              IsError: false,
              ErrorText: [],
              disable: rows[i].amount2.disable,
            },
            amount3: {
              value: rows[i].amount3.value,
              IsError: false,
              ErrorText: [],
              disable: rows[i].amount3.disable,
            },
            startDateType: {
              value:
                rows[i].startDate.value == undefined
                  ? 0
                  : rows[i].startDate.value.value == undefined
                  ? rows[i].startDateType.value
                  : rows[i].startDate.value.value,
              IsError: false,
              ErrorText: [],
              disable: rows[i].startDateType.disable,
            },
            startDate: {
              value:
                rows[i].startDate.value == undefined
                  ? 0
                  : rows[i].startDate.value.meta == undefined
                  ? rows[i].startDate.value
                  : rows[i].startDate.value.meta,
              IsError: false,
              ErrorText: [],
              disable: rows[i].startDate.disable,
              text: rows[i].startDate.text,
            },
            endDateType: {
              value:
                rows[i].endDate.value == undefined
                  ? 0
                  : rows[i].endDate.value.value == undefined
                  ? rows[i].endDateType.value
                  : rows[i].endDate.value.value,
              IsError: false,
              ErrorText: [],
              disable: rows[i].endDateType.disable,
            },
            endDate: {
              value:
                rows[i].endDate.value == undefined
                  ? 0
                  : rows[i].endDate.value.meta == undefined
                  ? rows[i].endDate.value
                  : rows[i].endDate.value.meta,
              IsError: false,
              ErrorText: [],
              disable: rows[i].endDate.disable,
              text: rows[i].endDate.text,
            },
            description: {
              value: rows[i].description.value,
              IsError: false,
              ErrorText: [],
              disable: rows[i].description.disable,
            },
            typeId: {
              value: AdvanceSuperFilter.Pension,
              IsError: false,
              ErrorText: [],
            },
            subTypeId: {
              value: rows[i].subTypeId.value,
              IsError: false,
              ErrorText: [],
            },
            clientID: {
              value:
                rows[i].clientID.value == undefined
                  ? this.clientId
                  : rows[i].clientID.value,
              IsError: false,
              ErrorText: [],
            },
            newRow: false,
          });
        }
      }
      return addtionalData;
    },

    emptyGridRow(data) {
      if (data == undefined) {
        return this.fillData();
      } else {
        let gridData = [];
        for (let i = 0; i < data.length; i++) {
          gridData.push(this.fillData(data[i]));
        }
        return gridData;
      }
    },

    fillData(data, subtypeid) {
      let IsDataundfined = data == undefined;
      let startDateType = IsDataundfined
        ? 0
        : data.startDateType.value == 0
        ? 6
        : data.startDateType.value;
      let endDateType = IsDataundfined
        ? 0
        : data.endDateType.value == 0
        ? 6
        : data.endDateType.value;
      let emptyObject = {
        subTypeId: {
          value: IsDataundfined ? subtypeid : data.subTypeId.value,
          IsError: IsDataundfined ? false : data.subTypeId.IsError,
          ErrorText: IsDataundfined ? [] : data.subTypeId.ErrorText,
          disable: IsDataundfined ? false : data.subTypeId.disable,
        },
        riskProfile: {
          value: IsDataundfined ? "0" : data.riskProfile.value,
          IsError: IsDataundfined ? false : data.riskProfile.IsError,
          ErrorText: IsDataundfined ? [] : data.riskProfile.ErrorText,
          disable: IsDataundfined ? false : data.riskProfile.disable,
        },
        amount3: {
          value: IsDataundfined ? "0" : data.amount3.value,
          IsError: IsDataundfined ? false : data.amount3.IsError,
          ErrorText: IsDataundfined ? [] : data.amount3.ErrorText,
          disable: IsDataundfined ? false : data.amount3.disable,
        },
        amount1: {
          value: IsDataundfined ? "0" : data.amount1.value,
          IsError: IsDataundfined ? false : data.amount1.IsError,
          ErrorText: IsDataundfined ? [] : data.amount1.ErrorText,
          disable: IsDataundfined ? false : data.amount1.disable,
        },
        startDateType: {
          value: IsDataundfined ? 0 : data.startDateType.value,
          IsError: IsDataundfined ? false : data.startDateType.IsError,
          ErrorText: IsDataundfined ? [] : data.startDateType.ErrorText,
          disable: IsDataundfined ? false : data.startDateType.disable,
        },
        amount2: {
          value: IsDataundfined ? "0" : data.amount2.value,
          IsError: IsDataundfined ? false : data.amount2.IsError,
          ErrorText: IsDataundfined ? [] : data.amount2.ErrorText,
          disable: IsDataundfined ? false : data.amount2.disable,
        },
        startDate: {
          value: IsDataundfined ? "" : data.startDate.value,
          IsError: IsDataundfined ? false : data.startDate.IsError,
          ErrorText: IsDataundfined ? [] : data.startDate.ErrorText,
          text: IsDataundfined
            ? ""
            : this.startOptionsNew().filter((x) => x.value == startDateType)[0]
                .text,
        },
        endDateType: {
          value: IsDataundfined ? 0 : data.endDateType.value,
          IsError: IsDataundfined ? false : data.endDateType.IsError,
          ErrorText: IsDataundfined ? [] : data.endDateType.ErrorText,
          disable: IsDataundfined ? false : data.endDateType.disable,
        },
        endDate: {
          value: IsDataundfined ? "" : data.endDate.value,
          IsError: IsDataundfined ? false : data.endDate.IsError,
          ErrorText: IsDataundfined ? [] : data.endDate.ErrorText,
          text:
            IsDataundfined || data.endDate.value == ""
              ? ""
              : this.startOptionsNew().filter((x) => x.value == endDateType)[0]
                  .text,
        },
        description: {
          value: IsDataundfined ? "" : data.description.value,
          IsError: IsDataundfined ? false : data.description.IsError,
          ErrorText: IsDataundfined ? [] : data.description.ErrorText,
          disable: IsDataundfined ? false : data.description.disable,
        },
        clientID: {
          value: IsDataundfined ? this.clientId : data.clientID.value,
        },
        typeId: {
          value: IsDataundfined
            ? AdvanceSuperFilter.Pension
            : data.typeId.value,
          IsError: IsDataundfined ? false : data.typeId.IsError,
          ErrorText: IsDataundfined ? [] : data.typeId.ErrorText,
          disable: IsDataundfined ? false : data.typeId.disable,
        },
        newRow: IsDataundfined ? true : false,
      };
      return emptyObject;
    },
    fillGrid() {
      let gridRows = [];
      if (this.baselineData.superAddtionalDetails != null) {
        let data = this.baselineData.superAddtionalDetails.filter(
          (sr) =>
            sr.typeId.value == AdvanceSuperFilter.Pension &&
            sr.clientID.value == this.clientId
        );
        if (data != null && data.length > 0) {
          gridRows = this.emptyGridRow(data);
        }
      }
      return gridRows;
    },
  },
};
</script>
<style lang="scss" module></style>
